export const Carfax = {
  name:'CarfaxComponent',    
  template://html
  `
      <div v-if="accountnumber" class="w-full h-9 flex justify-center my-1 carfax-accountnumber srp-hook-carproof-section">
        <div v-html="this.badges"></div>
      </div>
  `,
  props: {
      vin: String,
      accountnumber: String
  },    
  data(){
      return {
          badges: ""
      }
    },
  created() {
      if(this.accountnumber && this.accountnumber !== "")
          this.getCarfax();
  },
  methods:{
      getCarfax(){
        let params = { "vin" : this.vin, "account" : this.accountnumber};
        wp.ajax.post("get_leadbox_carfax_from_api", { 'params': params })
          .done((response) => {
            this.badges = JSON.parse(response);
          })
          .fail(() => {
            this.badges = JSON.parse("");
          });
      },
      formatLang(language) {
        if(language == 'fr_CA'){
          return 'FR'
        }       
        else{
          return 'EN'
        }   
      }
    }
}